import * as THREE from 'three';
import { GestorSatelite3d } from './gestor-satelite3d';
import { Datas3d } from '../scheme3d/datas3d';
import { Satelite3dComponent } from './satelite3d.component';
import { DB } from 'src/app/datas/db';
import { NearestFilter, Scene, Vector3 } from 'three';
import { Varios3d } from '../scheme3d/varios3d';
import { DatasSatelite } from './datas-satelite';
import { UtilsBuilder } from '../utils-builder';
import { Poste3d } from '../scheme3d/poste3d';
import { stringify } from '@angular/compiler/src/util';
import { ObjectUnsubscribedError } from 'rxjs';
import { reduce } from 'rxjs/operators';
import { ProjectData } from 'src/app/entities/project-data.entity';



export class ComputeSatelite3d {

	//private satelite3dComponent: Satelite3dComponent;
	private scene: THREE.Scene;
	private gestorSatelite3d: GestorSatelite3d;
	public datasSatelite: DatasSatelite;


	private root: THREE.Object3D;
	public work: THREE.Object3D;
	public marcador: THREE.Object3D;

	private projectData: ProjectData
	private bases = [];
	private SVectorAdjust: THREE.Vector3;
	private utilsBuilder: UtilsBuilder;
	//private budgetSatelite:BudgetSatelite;
	private _tiempoMaxWaitBudget = 0;
	private _maximoTiempoPermitido = 0;

	private __ray: THREE.Raycaster;
	private __direction: THREE.Vector3;
	private __distance = 5000;

	//private matLine: THREE.LineBasicMaterial; // USADO PARA DEBUGAR

	public matBlue: THREE.MeshBasicMaterial;
	public matRed: THREE.MeshBasicMaterial;
	public matYellow: THREE.MeshBasicMaterial;
	public matGreen: THREE.MeshBasicMaterial;
	public matWhite: THREE.MeshBasicMaterial;

	//############################################################################## DATOS USADOS PARA DIBUJAR LOS PERÍMETROS
	// Contadores para un proyecto.
	public DTCountDoor = 0;
	public DTCountWall = 0;
	public DTCountPost = 0;
	public DTCountTornaPuntas = 0;
	public DTCountPlaqueBase = 0;
	public DTCountEspino = 0;

	//Property to detect minimum distance to add panel
	readonly MIN_DISTANCE = 0.2;
	//Wall status depending on length increase or not
	readonly WALL_REDUCE_CONST = -1;
	readonly WALL_NOCHANGE_CONST = 0;
	readonly WALL_INCREASE_CONST = 1;
	//Previous wall status
	public previousWall = this.WALL_NOCHANGE_CONST;


	public DTNamePerTramo = '';				// Texto usado para ubicar los objetos 3D por perímetro y tramo. ??
	public DTTramoActual: any;				// Actual tramo que se está dibujando. ??
	//	public DTRootTramo: THREE.Object3D;		// Actual root 3D del tramo, usado para añadir nuevos hijos (mesh). ??

	public DTIndexPerimeter: number;		// Índice del actual perímetro.
	public DTPerimeterActual: Datas3d;		// Actual perímtero que se está dibujando.
	public DTRootPerimeter: THREE.Group;	// Actual perímtero que se está dibujando.
	public DTHeightPerimeter: number;		// Altura total del perímetero (altura del panel + muro) con ajuste a 5 metros de los poste 3D.
	//										 (5 - this.DTPerimeterActual.heightPost) + this.DTPerimeterActual.heigthWall
	public DTHeightTornapuntas: number;		// Altura general para colocar los tornapuntas por perímetro.
	//										((this.DTPerimeterActual.heightPost / 100) * 75) + this.DTHeightPerimeter)

	public DTMetersLUXAnudada = 0;			// Usada para continuar un bastidor de tramoa a tramo cuando es una LUX ANUDADA.

	private DTColorTornapuntas = '';		// Solo pueden tener color verde o galvanizado.

	private DTCacheY = 0;

	private readonly DTAnudadaInicial = 'LUX_ANUDADAInicial_';		// Prefijo para cargar malla inicial, solo ANUDADAS.
	private readonly DTAnudadaCentro = 'LUX_ANUDADACentro_';		// Prefijo para cargar malla centsal, solo ANUDADAS.
	private readonly DTAnudadaCarracas = 'LUX_ANUDADACarracas_';	// Prefijo para cargar malla carracas, solo ANUDADAS.

	//private utilsBuilder: UtilsBuilder;

	private DTAnudadas = {
		inicial: '',
		centro: '',
		carracas: ''
	};

	public DTHasColor = false;				// Si es false -> Galvanizado, en caso contrario tiene un color.
	public DTCacheMaterials = {				// Contiene todos los materiales usados en el perímetro en curso.
		'COL_PlacaBase': undefined,			// Usado para clonar material con el color actual de la placa base.
		'COL_Poste': undefined,
		'COL_Bayoneta': undefined,
		'COL_Bastidor': undefined,
		'COL_Abrazadera': undefined
	};

	public RAD90 = 1.5707963267948966;
	public RAD180 = 3.141592653589793;
	public RAD270 = 4.71238898038469;
	public RAD360 = 6.283185307179586;
	//#######################################################################################################################

	constructor(currentProjectData: ProjectData, currentDatasSatelite: DatasSatelite) {
		this.projectData = currentProjectData;
		this.datasSatelite = currentDatasSatelite;

		 this.__ray = new THREE.Raycaster();

		 this.scene = new THREE.Scene(); //satelite3dComponent.scene;

		// this.gestorSatelite3d = new GestorSatelite3d(this.projectData.perimetro, this.root, undefined); //satelite3dComponent.gestorSatelite3d;
		// this.SVectorAdjust = UtilsBuilder.latLngToVector3d(this.gestorSatelite3d.lat, this.gestorSatelite3d.lng);

		// this.drawBasePerimeters();

		//this.budget = satelite3dComponent.budgetSatelite;
		//this.satelite3dComponent = satelite3dComponent;
		//this.datasSatelite = this.satelite3dComponent.budgetSatelite.datasSatelite;

		// Crear las divisiones del perímetro, si obj3d = true carga los modelos 3D.

		// this.datasSatelite.insertNo3D(this.projectData, false);

		// // Calculate elevations and coors
		// //this.datasSatelite.calculateElevationsSatelite();

		// this.utilsBuilder = new UtilsBuilder();
		// for (let index = 0; index < this.projectData.perimetro.length; index++) {
		// 	let perimetro = this.projectData.perimetro[index];
		// 	// Actualiza perímetro cerrado, arrays ang1 y ang2.
		// 	this.utilsBuilder.iniciar(perimetro.coordenadas);
		// }

		// this.budgetSatelite = new BudgetSatelite(this.projectData);
		// this.datasSatelite.createBudgetData(false);


		//this.matLine = new THREE.LineBasicMaterial({ color: 0xffff00 }); COLOR DE LAS LÍNEAS QUE MARCAN LOS PUNTOS BASE, DEBUG.

		this.matBlue = new THREE.MeshBasicMaterial({ color: 0x0000ff });
		this.matRed = new THREE.MeshBasicMaterial({ color: 0xff0000 });
		this.matYellow = new THREE.MeshBasicMaterial({ color: 0xffff00 });
		this.matGreen = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
		this.matWhite = new THREE.MeshBasicMaterial({ color: 0xffffff });

		this.__direction = new THREE.Vector3(0, -10000, 0);
		this.__direction.normalize();

		// Iniciar contadores.
		this.DTCountDoor = 0;
		this.DTCountPost = 0;
		this.DTCountTornaPuntas = 0;
		this.DTCountWall = 0;
		this.DTCountPlaqueBase = 0;
		this.DTCountEspino = 0;

		//this.utilsBuilder = new UtilsBuilder();
	}

	// Llegados aquí ya se han calculado los perímetros y cargado los objetos 3D.
	public async initGestorSatelite() {
		this.initWorld3D();
		await this.calcularBoundMap(); // Crear el objeto.
		this.drawBasePerimeters(); // Se crean objetos 3D ocultos en cada base de los perímetros para provocar el calculo de la matriz.

		// TODO Rectificar para dejar como antes: Descomentar.
		//	this.work.rotation.set(-this.SRadianesLAT, -(this.SRadianesLNG / 100), 0);

		//this.espera();
	}

	// Espera a que se cree todo el mundo.
	private espera() {
		if (this.gestorSatelite3d?.canDraw) {
			// Dibujar.
			//let drawSatelite3d = new DrawSatelite3d(this);
			let OK = false;
			setTimeout(() => {
				if (!OK) {
					//this.avisoProblemas3D();
					//this.router.navigate(['/satelite']);
					//this.onFinish3DKO.emit();
				}
			}, 45000);
			//this.draw();
			//this.gestorSatelite3d?.canDraw = true;
			OK = true;
			//this.controls.meshesMap = this.gestorSatelite3d.meshesMap;
			//this.controls.enabled = true;


			//setTimeout(() => {
			//	this.initialContinuousRender = false;
			//	this.render();
			//}, 2000);

			//this.onFinish3DOK.emit();
		}
		else if (this._maximoTiempoPermitido > 45000) {
			// Avisar que no es pudo crear el mundo.
			console.error('No se pudo crear el mundo 3D.');
			//this.avisoProblemas3D()
			//this.router.navigate(['/satelite']);
			//this.onFinish3DKO.emit();
		}
		else {
			this._maximoTiempoPermitido += 300;
			setTimeout(() => { this.espera(); }, 300);
		}
	}

	// Array de arrays con las coordenadas y otros datos de interes según el mapa.
	// { x:0, y:0, z:0, angle:0, type:0 }
	private dotsReal = [];


	// Método que espera la gestión del presupuesto, si pasa el tiempo máximo sale y debe avisar que no se pudo realizar.
	/*private waitBudget() {
		if (this.budgetSatelite.proccessEnd && this.budgetSatelite.datasSatelite.loadFinish) {
			console.error('Budget:: OK!"');
			this.datasSatelite = this.budgetSatelite.datasSatelite;
		}
		else if (this._tiempoMaxWaitBudget > 45000) {
			console.error('Budget:: Tiempo límite pasado.');
		}
		else {
			setTimeout(() => {
				this._tiempoMaxWaitBudget += 300;
				this.waitBudget();
			}, 300);
		}
	}*/

	// ##### Dibuja los postes encima del mapa.
	public computeGeometry() {

		// #############################################################################################################################
		// ##### PERÍMETROS
		// Recorrer todo los prímetros del proyecto.
		for (this.DTIndexPerimeter = 0; this.DTIndexPerimeter < this.datasSatelite.datas.length; this.DTIndexPerimeter++) {
			//recorre los perímetros dibujados
			this.DTPerimeterActual = this.datasSatelite.datas[this.DTIndexPerimeter];

			// Actualizar altura general del perímetro restando la altura de los postes y de los muros
			this.DTHeightPerimeter = (5 - this.DTPerimeterActual.heightPost) - this.DTPerimeterActual.heigthWall;

			// Actualizar altura general de los tornapuntas.
			this.DTHeightTornapuntas = ((this.DTPerimeterActual.heightPost / 100) * 75) + this.DTHeightPerimeter + this.DTPerimeterActual.heigthWall;
			// console.log("****ALTURA DE TORNAPUNTAS ***", this.DTHeightTornapuntas);

			// Si es un cercado con malla Anudada, actualizar los prefijos.
			let tipo = this.DTPerimeterActual.mesh.substr(-7);
			this.DTAnudadas.inicial = this.DTAnudadaInicial + tipo;
			this.DTAnudadas.centro = this.DTAnudadaCentro + tipo;
			this.DTAnudadas.carracas = this.DTAnudadaCarracas + tipo;

			// Iniciar ciclo de cercado Anudada.
			this.DTMetersLUXAnudada = 0;

			// Reiniciar la cache de materiales con el color del perímetro.
			this.DTHasColor = false; //this.DTPerimeterActual.color != '';
			if (this.DTHasColor) {
				// Material usado para colorear.
				this.datasSatelite.ColorNeutro = new THREE.MeshPhongMaterial({ color: this.DTPerimeterActual.color, specular: 0, emissive: 0, shininess: 0 });

				// Poste.
				let result = this.datasSatelite.postes.clonePosteMaterial(this.DTPerimeterActual.typePost, this.DTPerimeterActual.color);

				let colBastidor = this.datasSatelite.bastidores.cloneVerjaMaterials(this.DTPerimeterActual.mesh, this.DTPerimeterActual.color);

				// COL_PlacaBase array de materiales.
				this.DTCacheMaterials = {
					'COL_PlacaBase': this.datasSatelite.varios.clonePlacaBaseMaterial(this.DTPerimeterActual.color),
					'COL_Poste': result.poste,
					'COL_Bayoneta': result.bayoneta,
					'COL_Bastidor': colBastidor.bastidor,
					'COL_Abrazadera': colBastidor.abrazadera
				};

				// Tornapuntas verde.
				this.DTColorTornapuntas = '';
			}
			else {
				// Tornapuntas galvanizado.
				this.DTColorTornapuntas = 'G';
			}

			// Se reinicia por cada perímetro, usada por la LUX ANUDADA.
			this.DTMetersLUXAnudada = 0;
			this.drawPerimeter();
		}
	}
	//dibuja el perímetro
	private drawPerimeter() {
		// Crear el root del perímetro.
		this.DTRootPerimeter = new THREE.Group();
		this.DTRootPerimeter.name = 'Perimeter_' + this.DTIndexPerimeter;
		this.root.add(this.DTRootPerimeter);	// Todos los perímetros son hijos del root.

		// Cache de todos los puntos base.
		this.dotsReal[this.DTIndexPerimeter] = [];

		//Init previousWall to no change, as it is the first stretch(tramo)
		this.previousWall = this.WALL_NOCHANGE_CONST;

		let step = (this.DTPerimeterActual.closed) ? 1 : 0;
		//let indexPost = 0;
		for (let indexCoor = 0; indexCoor < this.DTPerimeterActual.coors.length - step; indexCoor++) {
			//console.log("Coors length", this.DTPerimeterActual.coors.length)
			//coor =  secciones del perímetro => si tiene 4 lados, 4 secciones y dentro tiene subsecciones como puertas o muros.
			let coor = this.DTPerimeterActual.coors[indexCoor];
			//console.log("coor", coor);
			//console.log("step", step);
			let obj = this.bases[this.DTIndexPerimeter][indexCoor];
			// obj.updateMatrixWorld(true);
			obj.updateWorldMatrix(true, true);

			// Coordenadas del mundo real, sin transformaciones.
			let pointA = new THREE.Vector3(obj.matrixWorld.elements[12], obj.matrixWorld.elements[13], obj.matrixWorld.elements[14]);

			//let pointA = new THREE.Vector3(obj.position.x, obj.position.y, obj.position.z);

			// Comprobar si el punto 'pointA' colisiona con el mapa.
			let objs = this.rayMaps(pointA);
			if (objs.length > 0) {
				let o = objs[0];
				// Coloca el poste base, punto donde están los vértices del perímetro
				let poste = this.datasSatelite.postes.clonePost(this.DTPerimeterActual.typePost,
					'poste_' + this.DTIndexPerimeter + '_' + this.DTCountPost++, 0, 0,
					-this.DTPerimeterActual.direction);

				// Pintar el poste.
				if (this.DTHasColor) this.paintPost(poste);
				//se añaden los postes bases de cada uno en las coordenadas que le corresponden en la x, y y z
				poste.position.set(o.point.x, o.point.y - this.DTHeightPerimeter, o.point.z);

				this.DTRootPerimeter.add(poste);

				if (!this.DTPerimeterActual.closed) {
					if (this.DTPerimeterActual.coors[indexCoor].sections.length > 0
						&& this.DTPerimeterActual.coors[indexCoor].sections[0].door !== '') {
						poste.visible = false;
					}
					// Última coordenada
					else if (indexCoor === this.DTPerimeterActual.coors.length - 1) {
						let coorAux = this.DTPerimeterActual.coors[indexCoor - 1];
						if (coorAux.sections[coorAux.sections.length - 1].door !== '') {
							poste.visible = false;
						}
					}
				}
				else {
					if (this.DTPerimeterActual.coors[indexCoor].sections[0].door !== '') {
						poste.visible = false;
					}
				}

				this.dotsReal[this.DTIndexPerimeter].push({
					poste: poste,
					angle: coor.ang
					//type: tp //, inter: []
				});
			}
		}
		//console.log(this.DTPerimeterActual.closed = true)

		// TODO Tiempo de lo actual y tiempo de testear todo.

		// En caso de que el perímetro esté cerrado.
		if (this.DTPerimeterActual.closed && this.dotsReal) {
			this.dotsReal[this.DTIndexPerimeter].push({
				poste: this.dotsReal[this.DTIndexPerimeter][0].poste,
				angle: this.dotsReal[this.DTIndexPerimeter][0].ang,
				type: undefined //, inter: []
			});
		}

		// Rellenar los huecos.
		if (this.DTPerimeterActual.familia === DB.CERCADO) {
			this.subPostesCercados();
		}
		else {
			this.subPostesVerjas();
		}
	}

	//############################################################################################################ VERJAS
	//######## VERJAS
	// ##### Dibuja el relleno de los postes base de las verjas, antes se ha tenido que llamar a draw().
	//private lastPanelReference;
	//private lastDoorReference; // Se pone a undefined cuando el tramo no es de tipo puerta
	private subPostesVerjas() {
		// Datos reales según el mapa.
		//Postes iniciales de - los perímetros (donde se coloca cadda tramo)
		let reales = this.dotsReal[this.DTIndexPerimeter];
		//console.log("REALES ----");
		//console.log(reales);
		//console.log(this.DTPerimeterActual.perimetro.post);

		// Obtener las coors de Datas3d. El último no se procesa.
		let lastTramo = this.DTPerimeterActual.coors.length - 2;

		//Store previous wall height (used to calculate current wall height)
		this.lastWallHeight = undefined;

		// Almacenar la posicion Y del punto A.
		this.DTCacheY = reales[0].poste.position.y;
		//console.log("-------------COORS----");
		//console.log(this.DTPerimeterActual.coors);
		//Get pole(poste) diameter's, as it is the same for the compete perimeter
		let diametroPoste = this.datasSatelite.postes.length(this.DTPerimeterActual.typePost);
		//Store previous Y position for first pole in case of closed profiles
		let previousYForClosed = undefined;
		for (let iTramo = 0; iTramo < this.DTPerimeterActual.coors.length - 1; iTramo++) {
			//Se recorren las coordenadas de los tramos
			let tramo = this.DTPerimeterActual.coors[iTramo];
			//El poste Actual que está recorriendo
			let actual = reales[iTramo];
			//El siguiente poste que recorre del siguiente tramo
			let next = reales[iTramo + 1];

			//Store previous Y position for first pole in case of closed profiles
			if( this.DTPerimeterActual.closed && iTramo === 1){
				previousYForClosed = reales[0].poste.position.y;
			}

			// Corregir el primer poste.
			//if (iTramo === 0) {
			// Se debería tener en cuenta si está cerrado.
			//	if (this.DTPerimeterActual.closed) {
			// TODO tratarlo como si fuera inicio de tramo interno.
			//	}
			//	else {
			let angle = this.angleAtoB(actual.poste.position, next.poste.position);
			actual.poste.rotation.set(0, angle, 0);
			//	}
			//}
			if (!this.DTPerimeterActual.closed && iTramo == lastTramo) {
				next.poste.rotation.set(0, angle, 0);
			}

			//############################################################################
			// SOLO TIENE UNA SECCIÓN, ES UNA PUERTA O BASTIDOR.
			if (tramo.sections.length === 1) {
				// No es una puerta, poner solo bastidores.
				if (tramo.sections[0].door === '') {
					 this.drawPostesSectionVerja(actual.poste.position, next.poste.position, actual, iTramo, 0);

				}
				// Es una puerta, solo poner la puerta, sus postes pertenecen a los postes base.
				else {
					// Pone un poste y después la puerta, tener en cuanta la orientación y rotación.
					let door = this.datasSatelite.puertas.cloneDoorSateliteData(tramo.sections[0].door, this);
					if (door) {
						let r = this.angleAtoB(actual.poste.position, next.poste.position);
						door.position.set(actual.poste.position.x, actual.poste.position.y + this.DTHeightPerimeter, actual.poste.position.z);
						door.rotation.set(0, r, 0);
						this.DTRootPerimeter.add(door);
						this.__ajustHightPostAtoB(actual.poste.position, next.poste.position, door, false);
					}
				}
			}
			//############################################################################
			// HAY MÁS DE UNA SECCIÓN, PUEDE HABER COMBINACIÓN DE PUERTAS Y BASTIDORES.
			else {
				//Don't clone the position so modifications done due to heihgt will impact directly to the position.
				let auxActual = actual.poste.position;
				// console.log("Empieza el tramo con seccion", auxActual)
				let auxNext: THREE.Vector3;
				//let magnitud = actual.poste.position.distanceTo(next.poste.position);

				let a1 = auxActual.clone();
				let a2 = next.poste.position.clone();
				a1.y = 0;
				a2.y = 0;
				let magnitud = a1.distanceTo(a2);
				//Calculate direction of the stretch(tramo), and angle between the contiguous cathetus and the hypotenuse
				//Calcular direccion of the tramo, i el angular entre el cateto continuo y la hipotenusa
				let dir = next.poste.position.clone().sub(actual.poste.position).normalize();
				let angleDir = dir.clone().setY(0.0).angleTo(dir)

				//---------------------------------------------------------------------------------------
				// Keep in mind: magnitud is using the distance without elevation, in the contiguous cathetus
				// but auxActual & auxNext are calculated on hypotenuse. Operations bellow need to take this
				// into account and not mix both values.
				//---------------------------------------------------------------------------------------

				for (let iSection = 0; iSection < tramo.sections.length; iSection++) {


					// Obtenemos el tramo que tiene varias secciones, como una puerta, muro, etc
					let section = tramo.sections[iSection];
					// Si no es la primera sección, se debe crear el poste base.
					if (iSection > 0) {

						let objs = this.rayMaps(auxNext);
						if (objs.length > 0) {
							let o = objs[0];
							let angle = this.angleAtoB(auxActual, auxNext);
							// Coloca el poste base.




							let poste = this.datasSatelite.postes.clonePost(this.DTPerimeterActual.typePost,
								'poste_' + this.DTIndexPerimeter + '_' + this.DTCountPost++, 0, 0, -this.DTPerimeterActual.direction);
							poste.rotation.set(0, angle, 0);
							// console.log("this post is: ", poste.name);

							// Pintar el poste.
							if (this.DTHasColor) this.paintPost(poste);

							poste.position.set(o.point.x, o.point.y - this.DTHeightPerimeter - this.DTPerimeterActual.heigthWall, o.point.z);
							this.DTRootPerimeter.add(poste);
							auxActual = poste.position; // Toma el relevo como poste base principal.

							//Update the last pole(poste) position with the current calculation
							let prevSect = section = tramo.sections[ iSection -1 ];
							if( prevSect.postes !== undefined && prevSect.postes.length >= 1){
								prevSect.postes[prevSect.postes.length -1 ] = auxActual;
							}
						}
					}

					// if(iTramo > 0){
					// 	console.log();
					// 	if(this.lastBastidorHeight){
					// 		auxActual.y = this.lastBastidorHeight;
					// 		console.log("AUX ACTUAL======");
					// 		console.log(auxActual.y);
					// 	}
					// }

					// No es una puerta, poner solo bastidores.
					if (tramo.sections[iSection].door === '') {
						//this.lastDoorReference = undefined;

						// Tener en cuenta que es la última sección.
						// Take into account last section
						let magnitudAux = section.magnitud;
						if( iSection == (tramo.sections.length - 1)){
							//Corrección para acabar en los puntos exactos y no calculados. No hay clone para aplicar los cambios directamente.
							//Correction to finish in the exact point, instead of the calculated one. No clone to apply changes directly.
							auxNext = next.poste.position;
							magnitudAux = magnitud;
						}else{
							//FIX: Recalculamos la MagnitudAux teniendo en cuenta la diferencia de altura entre posicion actual y siguiente
							//let endSection = auxActual.clone().add((dir.clone().multiplyScalar(section.magnitud)));
							//let difY = endSection.y - auxActual.y;
							//let magnitudInHypo = Math.sqrt(Math.abs(Math.pow(magnitudAux,2) - Math.pow(difY,2)));
							//FIX2: calculate the magnitude in the hypotenuse direction
							let magnitudInHypo = section.magnitud / Math.cos(angleDir);

							// Crear un poste ficticio.
							//console.log("magnitudAux ---> " + magnitudAux);
							//const offset = 0.025

							//We use vector calculation instead of tramoAtoB cause it gives less calculation error
							//IMPORTANT: use magintude in hypotenuse as we are calculating auxNext
							auxNext = auxActual.clone().add(dir.clone().multiplyScalar(magnitudInHypo));
							//this.tramoAtoB(auxActual, next.poste.position, magnitudInHypo);
							if( iSection == (tramo.sections.length - 2) && tramo.sections[iSection +1].magnitud < this.MIN_DISTANCE){
								//Due to accumulated calculation error we can have a magnitude smaller than the needed for the extra pole(poste)
								//If that's case we reduce the previous section.
								auxNext = next.poste.position.clone().sub(dir.clone().multiplyScalar(tramo.sections[iSection +1].magnitud ));
							}
						}


						this.drawPostesSectionVerja(auxActual, auxNext, undefined, iTramo, iSection);

						//As we are decreasing magnitud, we use the value without elevation.
						magnitud -= magnitudAux;
						// Es una puerta, solo poner la puerta, sus postes pertenecen a los postes base.
					}
					else {
						//console.log(auxNext.y);
						if(this.lastBastidorHeight){
							if(auxActual.y < this.lastBastidorHeight){
								auxActual.y = this.lastBastidorHeight - this.DTHeightPerimeter - this.DTPerimeterActual.heigthWall;
							}
						}
						// Mover auxActual para que no se meta en el poste.
						// We need to add half pole(poste) diameter's to avoid door positioning inside the pole(poste)
						// Again calculate distance on hypotenuse, as we want to update auxActual
						let distHipoPoste = Math.abs(( (diametroPoste/2)) / Math.cos(angleDir));
						//let newAuxActual = this.tramoAtoB(auxActual, next.poste.position, distHipoPoste);
						//We use vector calculation instead of tramoAtoB cause it gives less calculation error
						//IMPORTANT: use magintude in hypotenuse as we are calculating auxNext
						let newAuxActual = auxActual.clone().add(dir.clone().multiplyScalar(distHipoPoste));
						auxActual = newAuxActual;
						// We need to recover the real length instead of the "theorical" one,
						// otherwise the fence will start inside the door or far way from it.
						let puertaDB = this.DTPerimeterActual.perimetro.puertas.find( e => e.puerta.ID === tramo.sections[iSection].door);
						let lengthDoor = puertaDB.puerta.longitudTotal/1000.0;
						//let lengthDoor = this.datasSatelite.puertas.length(tramo.sections[iSection].door);
						if (lengthDoor === 0) lengthDoor = section.magnitud

						//Calculate the complete length of the door in hypotenuse dimension
						let distHipo = Math.abs((lengthDoor + (diametroPoste/2)) / Math.cos(angleDir));

						//auxNext = this.tramoAtoB(auxActual, next.poste.position, distHipo);
						//We use vector calculation instead of tramoAtoB cause it gives less calculation error
						//IMPORTANT: use magintude in hypotenuse as we are calculating auxNext
						auxNext = auxActual.clone().add(dir.clone().multiplyScalar(distHipo));

						// TODO comparar last bas height con aux nextY ########
						magnitud -= (lengthDoor + (diametroPoste/2));

						// Pone un poste y después la puerta, tener en cuanta la orientción y rotación.
						let door = this.datasSatelite.puertas.cloneDoorSateliteData(tramo.sections[iSection].door, this);
						// console.log("La puerta la coloco",door)
						console.log(door);
						if (door) {
							//this.lastDoorReference = door;
							let r = this.angleAtoB(auxActual, auxNext);
							door.position.set(auxActual.x + this.DTHeightPerimeter, auxActual.y + this.DTHeightPerimeter, auxActual.z);
							door.rotation.set(0, r, 0);

							//auxNext.y = door.position.y - this.DTHeightPerimeter - this.DTPerimeterActual.heigthWall - 2;
							this.lastBastidorHeight = door.position.y;
							// Last paramenter to false: wall elevation should not be applied to doors
							this.__ajustHightPostAtoB(auxActual, auxNext, door,false);
							this.DTRootPerimeter.add(door);

							//Retreive last pole and if position with door is bigger than door height, correct it
							let prevPoste = this.getPreviousPoste(iSection, iTramo);
							if(prevPoste !==undefined &&  prevPoste.y < (auxNext.y - (puertaDB.puerta.alturaValor/1000))){
								prevPoste.setY( auxNext.y );
							}
						}
						//console.log(auxNext.y);
					}
				}
			}
		}

		//We get the maximum heihgt for the last/first pole in a closed perimeter
		if( this.DTPerimeterActual.closed ){
			reales[0].poste.position.setY(Math.max(previousYForClosed,reales[0].poste.position.y));
		}

		//Now paint extras for all stretches (tramos)
		for (let iTramo = 0; iTramo < this.DTPerimeterActual.coors.length - 1; iTramo++) {
			let tramo = this.DTPerimeterActual.coors[iTramo];
			for (let iSection = 0; iSection < tramo.sections.length; iSection++) {
				let section = tramo.sections[ iSection ];
				if( section.door === ''){
					let postes = section.postes
					if(postes === undefined)continue;
					let lengthBastidores = section.lengthBastidores;
					for( let index = 0; index < postes.length -1; index++){
						//console.log("--------------------------------------------");
						//console.log("tramo: "+ iTramo + " section: "+ iSection + " wall:"+ index);
						let vA = postes[index].clone();
						let vB = postes[index + 1].clone();
						let r = this.angleAtoB(vA, vB);

						//Store the type of the current wall: if we are increasing or decreasing the height from inital to en point.
						//This must be done before modifying the heights.
						let wallStatus = this.getWallStatus(vA,vB);
						//Check if it is the last post from the stretch ("Tramo")
						let lastPost = (index === postes.length - 2 );
						//Check if it is the last stretch ("Tramo") from the perimeter
						let lastTram = (iTramo === this.DTPerimeterActual.coors.length -2);
						//Check if it is the last section  from the stretch ("Tramo")
						let lastSection = (iSection === (tramo.sections.length - 1) );

						let nextWallStatus = this.getNextWallStatus(postes, index, iSection, iTramo );
						//If it is the first calculation of a closed perimeter, previous status should be the last one!
						if( iSection === 0 && iTramo === 0 && this.DTPerimeterActual.closed){
							let lastTramo = this.DTPerimeterActual.coors[this.DTPerimeterActual.coors.length -2];
							let lastSection = lastTramo.sections[lastTramo.sections.length -1];
							let postesLast = lastSection.postes;

							let previousWallStatus = this.getNextWallStatus(postesLast, postesLast.length-3, tramo.sections.length -1, this.DTPerimeterActual.coors.length - 2 )
							this.previousWall =  previousWallStatus.status;
							this.lastWallHeight = previousWallStatus.y;
						}
						/*if( lastPost && lastSection && lastTram && this.DTPerimeterActual.closed){
							lastSection = false;
						}*/
						//console.log("First vA.y:"+ vA.y + " vB.y:" + vB.y);

						//if(nextWallStatus.y > Math.min(vA.y,vB.y)){
						//if(lengthBastidores[index] == 0){
						if( Math.abs(vA.y - vB.y) > 0.001 )	{
							this.__ajustHightPostAtoB(vA, vB, undefined,true);
						}
						//continue;
						//console.log("Second vA.y:"+ vA.y + " vB.y:" + vB.y);

						// Placa base, bayoneta y muro.
						this.extras(vA, vB, r, ((index === 0) && (iSection===0) /*&& (iTramo===0)*/),
									(lastPost && lastSection /*&& (lastTram)*/ ),
									(lastPost && lastSection && lastTram ),
									lengthBastidores[index],
									(lengthBastidores.length == 1),
									wallStatus,nextWallStatus.status,nextWallStatus.y);
					}
				}else{
					this.previousWall = this.WALL_NOCHANGE_CONST;
				}
			}
		}
	}


	private getWallStatus(vA: THREE.Vector3, vB: THREE.Vector3){
		if( vA.y > vB.y){
			return this.WALL_REDUCE_CONST;
		}else{
			return this.WALL_INCREASE_CONST;
		}
	}

	private getFirstPosteNextSection(indexSection: number, indexTramo: number, useReal: boolean){
		//We need to calculate the first pole of the next section/stretch
		let tramo = this.DTPerimeterActual.coors[indexTramo];
		let vReturn = undefined;
		if( indexSection + 1 < tramo.sections.length - 1){
			//If next section is a door no need to calculate
			if( tramo.sections[indexSection + 1].door === ""){
				//We move to next section so we need to calculate first pole of it.
				if(tramo.sections[0].postes.length > 2){
					vReturn = tramo.sections[indexSection + 1].postes[1];
				}
			}
		}else if(indexTramo + 1 < this.DTPerimeterActual.coors.length - 1 || this.DTPerimeterActual.closed){
			let nextTramo = undefined;
			if( indexTramo + 1 < this.DTPerimeterActual.coors.length - 1){
				nextTramo = this.DTPerimeterActual.coors[indexTramo + 1];
			}else{
				nextTramo = this.DTPerimeterActual.coors[0];
			}
			//If next section is a door no need to calculate
			if( nextTramo !==undefined &&  nextTramo.sections[0].door === ""){
				if( useReal ){
					if(nextTramo.sections[0].postes != undefined && nextTramo.sections[0].postes.length >= 1){
						vReturn = nextTramo.sections[0].postes[0];
					}
				}else{
					//we move to next stretch and we need to calculate first pole of it.
					if(nextTramo.sections[0].postes != undefined && nextTramo.sections[0].postes.length >= 2){
						vReturn = nextTramo.sections[0].postes[1];
					}
				}
			}
		}else{
			//this means the final of the perimeter (as VB will remain undefined WALL_NOCHANGE will be returned)
		}
		return vReturn;
	}
	private getFirstLengthNextSection(indexSection: number, indexTramo: number){
		//We need to calculate the first pole of the next section/stretch
		let tramo = this.DTPerimeterActual.coors[indexTramo];
		let vReturn = undefined;
		if( indexSection + 1 < tramo.sections.length - 1){
			//If next section is a door no need to calculate
			if( tramo.sections[indexSection + 1].door === ""){
				//We move to next section so we need to calculate first pole of it.
				if(tramo.sections[ indexSection + 1].lengthBastidores.length >= 1){
					vReturn = tramo.sections[indexSection + 1].lengthBastidores[0];
				}
			}
		}else if(indexTramo + 1 < this.DTPerimeterActual.coors.length - 1 || this.DTPerimeterActual.closed){
			let nextTramo = undefined;
			if( indexTramo + 1 < this.DTPerimeterActual.coors.length - 1){
				nextTramo = this.DTPerimeterActual.coors[indexTramo + 1];
			}else{
				nextTramo = this.DTPerimeterActual.coors[0];
			}
			if( nextTramo !==undefined && nextTramo.sections[0].door === ""){
				if(nextTramo.sections[0].postes != undefined && nextTramo.sections[0].lengthBastidores.length >= 1){
					vReturn = nextTramo.sections[0].lengthBastidores[0];
				}
			}
		}else{
			//this means the final of the perimeter (as VB will remain undefined WALL_NOCHANGE will be returned)
		}
		return vReturn;
	}

	private getNextWallStatus(postes:any[], indexPoste: number, indexSection: number, indexTramo: number){
		let vA = undefined;
		let vB = undefined;
		let length = undefined;
		let tramo = this.DTPerimeterActual.coors[indexTramo];
		if( indexPoste < postes.length - 2){
			vA = postes[indexPoste + 1];
			vB = postes[indexPoste + 2];
			//length = tramo.sections[indexSection].lengthBastidores[indexPoste + 1];
		}else{
			vA = this.getFirstPosteNextSection(indexSection,indexTramo, true);
			vB= this.getFirstPosteNextSection(indexSection,indexTramo, false);
			//length = this.getFirstLengthNextSection(indexSection, indexTramo);
		}


		if(vA != undefined && vB != undefined){
			let origA = vA.clone();
			vA = vA.clone();
			vB = vB.clone();
			if(  Math.abs(vA.y - vB.y) > 0.001){//length === 0){
				this.__ajustHightPostAtoB(vA, vB, undefined,true);
			}
			return { status: this.getWallStatus(vA, vB), y: Math.min(vA.y,vB.y)};
		}else{
			return { status:this.WALL_NOCHANGE_CONST, y: (vA != undefined)?vA.y:(vB != undefined)?vB.y:undefined}
		}
	}

	private getPreviousPoste(indexSection: number, indexTramo: number){
		//We need to calculate the first pole of the next section/stretch
		let tramo = this.DTPerimeterActual.coors[indexTramo];
		let vReturn = undefined;
		if( indexSection - 1 >= 0 ){
			let prevSection = tramo.sections[indexSection - 1];
			//If next section is a door no need to calculate
			if( prevSection.door === ""){
				//We move to next section so we need to calculate first pole of it.
				if(prevSection.postes !== undefined && prevSection.postes.length >= 1){
					vReturn = prevSection.postes[prevSection.postes.length - 1];
				}
			}
		}else if(indexTramo - 1 >= 0   || this.DTPerimeterActual.closed){
			let nextTramo = undefined;
			if( indexTramo - 1 >= 0 ){
				nextTramo = this.DTPerimeterActual.coors[indexTramo - 1];
			}else{
				nextTramo = this.DTPerimeterActual.coors[this.DTPerimeterActual.coors.length - 1];
			}
			if( nextTramo !==undefined && nextTramo.sections.legnth >=1 ){
				let prevSection = nextTramo.sections[nextTramo.sections.length - 1];
				if(prevSection.door === "" && prevSection.postes !== undefined && prevSection.postes.length >= 1){
					vReturn = prevSection.postes[prevSection.postes.length - 1];
				}
			}
		}else{
			//this means the final of the perimeter (as VB will remain undefined WALL_NOCHANGE will be returned)
		}
		return vReturn;
	}

	// ##### Dibuja una parte o todo un tramo con la verja indicada.
	private lastPostHeight: number;
	private listPostesIniciales: any[] = [];
	private listBastidoresIniciales: any[] = [];
	private lastBastidorHeight: any;
	private lastWallHeight: number;
	private drawPostesSectionVerja(posteA: THREE.Vector3, posteB: THREE.Vector3, posteActual?:THREE.Object3D, indexTramo?:number, indexSection?:number) {
		const p1:THREE.Vector3 = posteA.clone();
		const p2:THREE.Vector3 = posteB.clone();

		p1.y = 0;
		p2.y = 0;

		let length = p1.distanceTo(p2);

		if(length < this.MIN_DISTANCE) {
			// This is the case for last double post, when using square posts.
			// Althought no panel should be created at least the height should be updated in case larger post is needed.
			let objsA = this.rayMapsAtoB(posteA, posteB, 0);
			if (objsA.length > 0) {
				let o = objsA[0];
				posteA.set(o.point.x, o.point.y - this.DTHeightPerimeter, o.point.z)
			}
			if(this.lastBastidorHeight - this.DTHeightPerimeter > posteA.y){
				posteA.setY(posteA.y + (this.lastBastidorHeight-posteA.y) - this.DTHeightPerimeter - this.DTPerimeterActual.heigthWall);
			}
			let vA = posteA.clone();
			let vB = posteB.clone();

			let oPrevPoste = this.getPreviousPoste(indexSection, indexTramo);
			vA.y = (oPrevPoste === undefined ? vA.y:oPrevPoste.y);//this.lastWallHeight;
			vB.y = (oPrevPoste === undefined ? vB.y:oPrevPoste.y);//this.lastWallHeight;
			// Poner postes.
			let postes = []; // Colocar el poste base 'posteA' en primer puesto.
			postes.push(vA);

			postes.push(vB);
			let lengthBastidores = [];
			lengthBastidores.push(length);
			//Check if next section is a section with a Door
			let tramo = this.DTPerimeterActual.coors[indexTramo];
			tramo.sections[indexSection].postes = postes;
			tramo.sections[indexSection].lengthBastidores = lengthBastidores;
			return;
		}

		let angle = this.angleAtoB(posteA, posteB);

		if (length > this.DTPerimeterActual.separation) {
			//this.DTPerimeterActual.separation = cada poste está colocado
			// Unidad divisoría del bastidor.
			let unidad = this.DTPerimeterActual.separation / 100;

			//se calculan cuantos bastidores hay que colocar entre las distancias que se calculan,
			let div = Math.floor(length / this.DTPerimeterActual.separation);

			let margenEnd = length % this.DTPerimeterActual.separation;
			let margenStart = this.DTPerimeterActual.separation;

			// En caso de que el resto sea un 30% más pequeño que la medida del bastidor => distribuir.
			if ((margenEnd / unidad) < 30) {
				margenStart = (margenStart + margenEnd) / 2;
				margenEnd = margenStart;
			}

			// Poner postes.
			let postes = []; // Colocar el poste base 'posteA' en primer puesto.
			postes.push(posteA);
			let inicioDraw = margenStart;
			// se colocan todos los postes del perímetro
			// div = al numero de postes que se colocan en la section
			for (let i = 0; i < div; i++) {
				let objs = this.rayMapsAtoB(posteA, posteB, inicioDraw);
				//obj = a todos los postes que se dibujan
				if (objs.length > 0) {
					let o = objs[0];
					let poste = this.datasSatelite.postes.clonePost(this.DTPerimeterActual.typePost, 'poste_' + this.DTCountPost++, 0, 0, -this.DTPerimeterActual.direction);
					poste.rotation.set(0, angle, 0);
					// Pintar el poste.
					if (this.DTHasColor) this.paintPost(poste);
					poste.position.set(o.point.x, o.point.y - this.DTHeightPerimeter, o.point.z);

					// Almacenar los postes para la segunda vuelta, colocar los bastidores.
					postes.push(poste.position);

					//console.log(poste.name);
					//console.log(poste.position);

					this.DTRootPerimeter.add(poste);
				}
				inicioDraw += this.DTPerimeterActual.separation;
			}
			//Last post should be also tested against the height, otherwise it can be incorrect.
			//In case we need to update it, we do in the same position so the representation is updated.
			let objsB = this.rayMapsAtoB(posteA, posteB, length);
			if (objsB.length > 0) {
				let o = objsB[0];
				posteB.set(o.point.x, o.point.y - this.DTHeightPerimeter, o.point.z)
			}
			postes.push(posteB); // La lista debe finalizar con el poste base 'posteB'.


			// Colocar los bastidores.
			// console.log({ postes });
			let bastidores = [];
			//Store length of panels (bastidores)
			let lengthBastidores = [];
			for (let iPoste = 0; iPoste < postes.length - 1; iPoste++) {
				//posicion del poste actual
				let vA = postes[iPoste];//.clone();
				let vB = postes[iPoste + 1];//.clone();
				let r = this.angleAtoB(vA, vB);
				let realA = vA.clone();
				if( iPoste === 0 && indexSection === 0){
					let objsA = this.rayMapsAtoB(posteA, posteB, 0);
					if (objsA.length > 0) {
						let o = objsA[0];
						realA.set(o.point.x, o.point.y - this.DTHeightPerimeter, o.point.z)
					}
					//console.log("Section : " + indexSection + " vA.y:" + vA.y + " realA.y:" + realA.y)
					vA = realA;
				}

				// console.log("--POSTE ACTUAL ALTURA VA---",postes[iPoste].y)
				// console.log("--POSTE SIGUIENTE ALTURA VB---",postes[iPoste + 1].y)

				let bas = undefined;
				let lengthBastidor = 0;
				if (iPoste === 0 && margenStart !== this.DTPerimeterActual.separation) {
					lengthBastidor = this.DTPerimeterActual.separation - margenStart;

					// console.log("THIS.DTPerimeterActual.mesh",this.DTPerimeterActual.mesh, "margenStar", margenStart ," this.DTPerimeterActual.separation",this.DTPerimeterActual.separation)
					bas = this.datasSatelite.bastidores.cloneEspecial(this.DTPerimeterActual.mesh, margenStart / this.DTPerimeterActual.separation,
						-this.DTPerimeterActual.direction, 0, this.datasSatelite.ColorNeutro, undefined);
				}

				else if (iPoste === postes.length - 2 && margenEnd !== this.DTPerimeterActual.separation) {
					lengthBastidor = this.DTPerimeterActual.separation - margenEnd;

					bas = this.datasSatelite.bastidores.cloneEspecial(this.DTPerimeterActual.mesh, margenEnd / this.DTPerimeterActual.separation,
						-this.DTPerimeterActual.direction, 0, this.datasSatelite.ColorNeutro, undefined);
				}

				else {
					bas = this.datasSatelite.bastidores.cloneVerjaSimple(this.DTPerimeterActual.mesh);
				}

				bastidores.push(bas);


				// console.log("___________");
				// console.log("indexTramo: " + indexTramo + " | indexSection: " + indexSection);
				// console.log("Before -> " + vB.y);
				// Last paramenter to true: wall elevation should be applied to panels
				this.__ajustHightPostAtoB(vA, vB, bas,true);
				// console.log("After -> " + vB.y);
				if( iPoste === 0 && indexSection === 0){
					if( vA.y > postes[iPoste].y){
						postes[iPoste].y =vA.y;
					}
				}


				if (this.DTHasColor) {
					this.datasSatelite.bastidores.paintBastidor2(bas, this.datasSatelite.ColorNeutro, this.DTCacheMaterials.COL_Bastidor,
						this.DTCacheMaterials.COL_Abrazadera);
				}

				// Rotar el bastidor.
				bas.rotation.set(0, r, 0);
				this.lastBastidorHeight = bas.position.y;

				/*
				if(angle < 0 ) {
					console.log("Pendiente ascendiente");
					const raycaster = new THREE.Raycaster();
					raycaster.set(debugSpheres[iPoste].position, new THREE.Vector3(0,-1,0));
					intersects = raycaster.intersectObjects([this.DTRootPerimeter.parent.getObjectByName('Suelo_0')]);
				} else {
					console.log("Pendiente descendiente");
					const raycaster = new THREE.Raycaster();
					raycaster.set(debugSpheres[iPoste + 1].position, new THREE.Vector3(0,-1,0));
					intersects = raycaster.intersectObjects([this.DTRootPerimeter.parent.getObjectByName('Suelo_0')]);
				}
				if(intersects.length > 0){
					//console.log('Diferencial nueva pos de panel e intersects');

					let dif = bas.position.y - intersects[0].point.y;
					diferencialesPoste.push(dif);

				}
				*/

				this.DTRootPerimeter.add(bas);

				// ######### MARCADOR
				this.setMarcador(bas.position, r);


				lengthBastidores.push(lengthBastidor);


			}
			//Check if next section is a section with a Door
			let tramo = this.DTPerimeterActual.coors[indexTramo];
			//Store poles(postes) and panel lengths (lengthBastidores) for painting walls
			tramo.sections[indexSection].postes = postes;
			tramo.sections[indexSection].lengthBastidores = lengthBastidores;
			// Nos guardamos la posicion en altura del ultimo poste de la seccion
			this.lastPostHeight = postes[postes.length-1].y;

		} else {

			let postes = []; // Colocar el poste base 'posteA' en primer puesto.
			//Store length of panels (bastidores)
			let lengthBastidores = [];
			lengthBastidores.push(this.DTPerimeterActual.separation - length);

			//Last post should be also tested against the height, otherwise it can be incorrect.
			//In case we need to update it, we do in the same position so the representation is updated.
			let objsB = this.rayMapsAtoB(posteA, posteB, length);
			if (objsB.length > 0) {
				let o = objsB[0];
				posteB.set(o.point.x, o.point.y - this.DTHeightPerimeter, o.point.z)
			}

			console.log("DrawPostesSectionVerjas:: el tramo es más pequeño que la longitud entre postes");

			// Ocurre cuando el tramo es más pequeño que la longitud entre postes.
			let bas = this.datasSatelite.bastidores.cloneEspecial(this.DTPerimeterActual.mesh,
				length / this.DTPerimeterActual.separation, -this.DTPerimeterActual.direction, 0, this.datasSatelite.ColorNeutro, undefined);

			//Adjunt poles(postes) height
			this.__ajustHightPostAtoB(posteA, posteB, bas,true);
			//bas.position.set(posteA.x, Math.max(posteA.y,posteB.y) + this.DTHeightPerimeter + this.DTPerimeterActual.heigthWall, posteA.z);
			postes.push(posteA);
			postes.push(posteB); // La lista debe finalizar con el poste base 'posteB'.

			if (this.DTHasColor) {
				this.datasSatelite.bastidores.paintBastidor2(bas, this.datasSatelite.ColorNeutro,
					this.DTCacheMaterials.COL_Bastidor, this.DTCacheMaterials.COL_Abrazadera);
			}
			let r = this.angleAtoB(posteA, posteB);
			bas.rotation.set(0, r, 0);
			this.DTRootPerimeter.add(bas);

			// ######### MARCADOR
			this.setMarcador(bas.position, r);


			let tramo = this.DTPerimeterActual.coors[indexTramo];
			//Store poles(postes) and panel lengths (lengthBastidores) for painting walls
			tramo.sections[indexSection].postes = postes;
			tramo.sections[indexSection].lengthBastidores = lengthBastidores;
			// Nos guardamos la posicion en altura del ultimo poste de la seccion
			this.lastPostHeight = postes[postes.length-1].y;
		}
	}

	//Receive a parameter to apply or not the height of the wall, as it shouldn't be applied to doors, f.e.
	private __ajustHightPostAtoB(vA: Vector3, vB: Vector3, obj: any, applyheightWall: boolean) {

		let intersects = []
		//########TICKET ESPRIVISA-21########
		//DTCacheY = vA.y que es la altura del poste siguiente al que se está recorriendo
		// En caso de que DTCacheY sea mayor o igual a la altura del poste siguiente (vA.y)
		//si la altura del poste actual es mayor o igual que la altura del poste siguiente
		if (vA.y > vB.y) {
			intersects = this.rayMaps(vA);
			//se coloca la posición de: X = Altura del poste actual, Y = altura del poste siguiente y la altura del muro, y la Z del poste actual
			// Se crea la diferencia entre la altura del poste A menos la Altura del poste B
			//let diferencia = vA.y - intersects[0].point.y;
			//Check obj is not null
			if(obj !== undefined){
				obj.position.set(vA.x, intersects[0].point.y + (applyheightWall?this.DTPerimeterActual.heigthWall:0.0), vA.z);
			}
			//this.DTCacheY = vB.y;
			//vB.setY(vA.y + diferencia);
			//Apply new Y without depending on object
			vB.setY(intersects[0].point.y - this.DTHeightPerimeter );
			//console.log("////////////////////////////////////////");
		}
		//la altura del siguiente vB.y poste es superior al poste actual vB.a
		else {
			intersects = this.rayMaps(vB);
			//let diferencia = vB.y - vA.y;
			// if(diferencia > 0.2){
			// 	obj.position.set(vA.x, vB.y + this.DTHeightPerimeter - diferencia + this.DTPerimeterActual.heigthWall, vA.z)
			// }else{
			// obj.position.set(vA.x, vB.y + this.DTHeightPerimeter + this.DTPerimeterActual.heigthWall, vA.z);
			//Check obj is not null
			if(obj !== undefined){
				obj.position.set(vA.x, intersects[0].point.y + (applyheightWall?this.DTPerimeterActual.heigthWall:0.0), vA.z);
			}
			// this.DTCacheY = vB.y;
			//console.log("\nHa entrado. -+-+-+-+-\n");
			//Apply new Y without depending on object
			vA.setY(intersects[0].point.y - this.DTHeightPerimeter );
		}
			//obj.position.set(vA.x, vB.y + this.DTHeightPerimeter + this.DTPerimeterActual.heigthWall + 4, vA.z);
		//}
	}

	// ######### MARCADOR
	private setMarcador(position: THREE.Vector3, rotation: number) {
		// let mar = this.datasSatelite.varios.cloneMarcador();
		// if (mar) {
		// 	mar.position.copy(position);
		// 	mar.rotation.set(0, rotation, 0);
		// 	this.satelite3dComponent.marcador.add(mar);
		// 	return true;
		// }
		// return false;
	}

	//Calculation of the offset (starting point) and length of the wall, in order to show the complete post for
	//increasing or decreasing walls.
	private calcWallOffset( pointA: THREE.Vector3, pointB: THREE.Vector3, wallHeight: number, nextWallHeight: number,
							wallStatus: number, nextWallStatus:number, first: boolean, last: boolean){
		let diametroPoste = this.datasSatelite.postes.length(this.DTPerimeterActual.typePost);
		let dir = pointB.clone().setY(0.0).sub(pointA.clone().setY(0.0)).normalize();
		let extraLengthWall = 0.0;
		let offsetWall = new THREE.Vector3(0.0,0.0,0.0);
		if( this.previousWall === this.WALL_NOCHANGE_CONST ){
			offsetWall = dir.clone().multiplyScalar(-diametroPoste/2);
			if( wallHeight < nextWallHeight ){
				extraLengthWall = (diametroPoste);
			}else if(wallHeight === nextWallHeight ){
				extraLengthWall = (diametroPoste/2);
			}
			if( nextWallStatus === this.WALL_NOCHANGE_CONST){
				extraLengthWall = (diametroPoste);
			}
		}else if( nextWallStatus === this.WALL_NOCHANGE_CONST){
			if( wallHeight < this.lastWallHeight){
				offsetWall = dir.clone().multiplyScalar(-diametroPoste/2);
				extraLengthWall = (diametroPoste);
			}else if( wallHeight > this.lastWallHeight ){
				offsetWall = dir.clone().multiplyScalar(diametroPoste/2);
			}else if( wallHeight === this.lastWallHeight ){
				extraLengthWall = (diametroPoste)/2;
			}
		}else{
			if( wallHeight < this.lastWallHeight ){
				offsetWall = dir.clone().multiplyScalar(-diametroPoste/2);
				if( wallHeight < nextWallHeight){
					extraLengthWall = diametroPoste;
				}else if( wallHeight == nextWallHeight ){
					extraLengthWall = diametroPoste;
				}
			}else if( wallHeight > this.lastWallHeight ){
				offsetWall = dir.clone().multiplyScalar(diametroPoste/2);
				if( wallHeight > nextWallHeight ){
					extraLengthWall = -diametroPoste;
				}else if( wallHeight == nextWallHeight ){
					extraLengthWall = diametroPoste;
				}
			}else{
				if( wallHeight > nextWallHeight ){
					offsetWall = dir.clone().multiplyScalar(-diametroPoste/2);
					//extraLengthWall = -diametroPoste/2;
				}else if( wallHeight < nextWallHeight){
					offsetWall = dir.clone().multiplyScalar(diametroPoste/2);
					//extraLengthWall = -diametroPoste/2;
				}else{
					offsetWall = dir.clone().multiplyScalar(-diametroPoste/2);
					extraLengthWall = diametroPoste;
				}
			}
		}
		//console.log("WallHeight:" + wallHeight + " lastWallHeight:"+ this.lastWallHeight + " nextWallHeihgt:"+ nextWallHeight);
		if(last && (wallHeight < nextWallHeight || nextWallHeight === undefined )){
			//console.log("Appy Last extension");
			extraLengthWall += 0.08;
		}
		if(first && (wallHeight < this.lastWallHeight || this.lastWallHeight === undefined )){
			//console.log("Appy First extension");
			extraLengthWall += 0.08;
			offsetWall.add( dir.clone().multiplyScalar(-0.08) );
		}
		this.previousWall = wallStatus;
		//console.log("PointA.y:" + pointA.y + " PointB.y:" + pointB.y + "Dir:" +  "(" + dir.x + " , " + dir.y + " , " + dir.z + ")");
		//console.log("Desp Muro(" + offsetWall.x + " , " + offsetWall.y + " , " + offsetWall.z + ") extraMuro:" + extraLengthWall);

		return { length: extraLengthWall, offset: offsetWall};
	}

	// Placa base, bayoneta y muro.
	private extras(pointA: THREE.Vector3, pointB: THREE.Vector3, angle: number, first: boolean, lastInSection: boolean, lastInPerimeter: boolean,
					// Added information needed to calculate the size of the walls
					lengthWall = 0, uniqueSection?: boolean, wallStatus?: number, nextWallStatus?: number, nextWallY?: number) {
		//let leng = pointA.distanceTo(pointB);
		if (this.DTPerimeterActual.basePlaque) {
			//Plate needs to be positioned in the lower section!
			this.setPlacaBase2(pointA, angle, Math.min(pointA.y,(this.lastWallHeight != undefined)?this.lastWallHeight:0.0,pointB.y) + this.DTHeightPerimeter);
			//For the last pole in the section, we also need to put a plate
			if(lastInPerimeter && !this.DTPerimeterActual.closed){
				this.setPlacaBase2(pointB, angle, pointB.y + this.DTHeightPerimeter);
			}
		}

		// Colocar espino de las bayonetas si corresponde.
		if (this.DTPerimeterActual.bayonet !== '') {
			let adjust80_50 = (this.DTPerimeterActual.typePost.indexOf('50') > -1) ? -0.04 : 0;
			let bay = this.datasSatelite.varios.cloneEspino2(pointA, pointB, adjust80_50, -this.DTPerimeterActual.direction);
			if (!bay) return undefined;

			bay.rotation.set(0, angle, 0);

			bay.name = 'Espino' + this.DTNamePerTramo + this.DTCountEspino++;
			this.DTRootPerimeter.add(bay);

			// En caso de ser bayoneta doble.
			if (this.DTPerimeterActual.bayonet == 'BD') {
				let bay2 = bay.clone();
				if (!bay2) return;

				bay2.scale.z *= -1;
				bay2.name = 'Espino' + this.DTNamePerTramo + this.DTCountEspino++;
				this.DTRootPerimeter.add(bay2);
			}
		}
		// Colocar muro.
		if (this.DTPerimeterActual.heigthWall > 0) {
			let lng = this.DTPerimeterActual.separation;

			//console.log("Muro status : "+ wallStatus + " previous:" + this.previousWall + "nextStatus:" + nextWallStatus);
			let extraLengthWall = 0.0;
			let offsetWall = new THREE.Vector3(0.0,0.0,0.0);

			let h = ((5 - this.DTPerimeterActual.heightPost) - this.DTPerimeterActual.heigthWall) - 1;

			//console.log("Muro status : "+ wallStatus + " previous:" + this.previousWall + "nextStatus:" + nextWallStatus);
			let p = (pointA.y > pointB.y) ? pointB.y : pointA.y;
			if( uniqueSection && lengthWall != 0 && lengthWall < this.MIN_DISTANCE){
				p = this.lastWallHeight;
				lengthWall = this.DTPerimeterActual.separation - lengthWall;
			}
			//console.log("Y:" + (p+h));

			let result = this.calcWallOffset( pointA, pointB, p, nextWallY, wallStatus, nextWallStatus, first, lastInSection);
			extraLengthWall = result.length;
			offsetWall = result.offset;
			this.lastWallHeight = p;
			if( lng - lengthWall + extraLengthWall < 0){
				return;
			}
			//console.log("lng :" + (lng - lengthWall + extraLengthWall));
			let wall = this.datasSatelite.varios.cloneWall(lng - lengthWall + extraLengthWall, this.DTPerimeterActual.heigthWall + 1);
			if (wall) {
				wall.name = 'wall' + this.DTNamePerTramo + this.DTCountWall++;


				//Apply calculated offset
				wall.position.set(pointA.x + offsetWall.x , p + h, pointA.z + offsetWall.z);

				wall.rotation.y = angle;
				this.DTRootPerimeter.add(wall);
			}
		}
	}

	// Placa base, bayoneta y muro.
	private extrasCercados(pointA: THREE.Vector3, pointB: THREE.Vector3, angle: number, first: boolean, last: boolean, lengthWall = 0) {
		//let leng = pointA.distanceTo(pointB);
		if (this.DTPerimeterActual.basePlaque) {
			this.setPlacaBase2(pointA, angle, pointA.y + this.DTHeightPerimeter);
		}

		// Colocar espino de las bayonetas si corresponde.
		if (this.DTPerimeterActual.bayonet !== '') {
			let adjust80_50 = (this.DTPerimeterActual.typePost.indexOf('50') > -1) ? -0.04 : 0;
			let bay = this.datasSatelite.varios.cloneEspino2(pointA, pointB, adjust80_50, -this.DTPerimeterActual.direction);
			if (!bay) return undefined;

			bay.rotation.set(0, angle, 0);

			bay.name = 'Espino' + this.DTNamePerTramo + this.DTCountEspino++;
			this.DTRootPerimeter.add(bay);

			// En caso de ser bayoneta doble.
			if (this.DTPerimeterActual.bayonet == 'BD') {
				let bay2 = bay.clone();
				if (!bay2) return;

				bay2.scale.z *= -1;
				bay2.name = 'Espino' + this.DTNamePerTramo + this.DTCountEspino++;
				this.DTRootPerimeter.add(bay2);
			}
		}
		// Colocar muro.
		if (this.DTPerimeterActual.heigthWall > 0) {
			let lng = this.DTPerimeterActual.separation;
			if (first) { // Es el primero de un tramo, se debe dar un margen principal para que no quede el poste en el aire.
				lng += 0.08;
			}
			if (last) lng += 0.08; // Es el último de un tramo, se debe dar un margen principal para que no quede el poste en el aire.

			let wall = this.datasSatelite.varios.cloneWall(lng - lengthWall, this.DTPerimeterActual.heigthWall + 1);
			if (wall) {
				wall.name = 'wall' + this.DTNamePerTramo + this.DTCountWall++;
				let h = ((5 - this.DTPerimeterActual.heightPost) - this.DTPerimeterActual.heigthWall) - 1;
				if (first) {
					let aux = this.tramoAtoB(pointA, pointB, -0.08);
					wall.position.set(aux.x, aux.y + h, aux.z);
				}
				else {
					let p = (pointA.y > pointB.y) ? pointB.y : pointA.y;
					wall.position.set(pointA.x, p + h, pointA.z);
				}
				wall.rotation.y = angle;
				this.DTRootPerimeter.add(wall);
			}
		}
	}

	//############################################################################################################ CERCADOS
	//######## CERCADOS
	// Dibuja el relleno de los postes base de las cercados, antes se ha tenido que llamar a draw().
	private subPostesCercados() {
		// Datos reales según el mapa.
		let reales = this.dotsReal[this.DTIndexPerimeter];

		// Obtener las coors de Datas3d. El último no se procesa.
		let lastTramo = this.DTPerimeterActual.coors.length - 2;
		let previousAngle = 0;
		let actualAngle = 0;
		let nextAngle = 0;
		let onlyOne = (this.DTPerimeterActual.coors.length === 2);

		for (let iTramo = 0; iTramo < this.DTPerimeterActual.coors.length - 1; iTramo++) {
			let tramo = this.DTPerimeterActual.coors[iTramo];
			let actual = reales[iTramo];
			let next = reales[iTramo + 1];
			if (!next) continue;
			// Actualizar angulos.
			if (iTramo > 0) previousAngle = actualAngle;

			actualAngle = this.angleAtoB(actual.poste.position, next.poste.position);
			actual.poste.rotation.set(0, actualAngle, 0);

			// if (!onlyOne) {
			// 	nextAngle = (this.DTPerimeterActual.closed) ?
			// 		this.angleAtoB(next.poste.posit ion, reales[0].poste.posit ion) :
			// 		this.angleAtoB(next.poste.posi tion, reales[iTramo + 2].poste.posit ion);
			// }

			const ITS_DOOR = tramo.sections[0].door !== '';

			// Tornapuntas para poste base inicial intermedios y final, solo CERCADOS.
			// __________ PRIMER POSTE.
			if (iTramo === 0) { // Es el primero, tener en cuenta si está cerrado.
				if (this.DTPerimeterActual.closed) {
					// Si está cerrado comprobar su angulo para poner los tornapuntas (40 a 140 grados).
					if (tramo.grados >= 40 && tramo.grados <= 140 && !ITS_DOOR) {
						this.setTornapuntas2(Varios3d.TornaPuntasIzquierdo, actual.poste.position, actualAngle);
					}
				}
				else {
					if (!ITS_DOOR) {
						this.setTornapuntas2(Varios3d.TornaPuntasIzquierdo, actual.poste.position, actualAngle);
					}
					// Si el perímetro es de un solo tramo, finalizar el tornapuntas.
					if (this.DTPerimeterActual.coors.length === 2
						&& tramo.sections[tramo.sections.length - 1].door === '') {
						this.setTornapuntas2(Varios3d.TornaPuntasDerecho, next.poste.position, actualAngle);
					}
				}
			}
			// __________ POSTE PENULTIMO.
			else if (iTramo === lastTramo) {
				if (this.DTPerimeterActual.closed) {
					// Si está cerrado comprobar su angulo para poner los tornapuntas (40 a 140 grados).
					let auxTramo = this.DTPerimeterActual.coors[0];
					if (auxTramo.grados >= 40 && auxTramo.grados <= 140) {
						this.setTornapuntas2(Varios3d.TornaPuntasDerecho, next.poste.position, actualAngle);
					}
				}
				else {
					const __lastTramo = this.DTPerimeterActual.coors[iTramo];
					if (__lastTramo.sections[__lastTramo.sections.length - 1].door === '') {
						this.setTornapuntas2(Varios3d.TornaPuntasDerecho, next.poste.position, actualAngle);
						next.poste.rotation.set(0, actualAngle, 0);
					}
				}
			}
			else if (this.DTPerimeterActual.coors.length == 2) {
				this.setTornapuntas2(Varios3d.TornaPuntasDerecho, next.poste.position, actualAngle);
			}

			//############################################################################
			// SOLO TIENE UNA SECCIÓN, ES UNA PUERTA O MALLA.
			if (tramo.sections.length === 1) {
				// No es una puerta, poner solo mallas.
				if (!ITS_DOOR) {
					this.drawPostesSectionCercado(actual.poste.position, next.poste.position);
					if (iTramo > 0 && tramo.grados >= 40 && tramo.grados <= 140) {
						this.setTornapuntas2(Varios3d.TornaPuntasIzquierdo, actual.poste.position, actualAngle);

						const anteriorTramo = this.DTPerimeterActual.coors[iTramo - 1];
						const ultimaSeccion = anteriorTramo.sections[anteriorTramo.sections.length - 1];
						if (ultimaSeccion.door === '') {
							this.setTornapuntas2(Varios3d.TornaPuntasDerecho, actual.poste.position, previousAngle);
						}
					}
				}
				// Es una puerta, solo poner la puerta, sus postes pertenecen a los postes base.
				else {
					// Pone un poste y después la puerta, tener en cuanta la orientción y rotación.
					let door = this.datasSatelite.puertas.cloneDoorSateliteData(tramo.sections[0].door, this);
					let r = this.angleAtoB(actual.poste.position, next.poste.position);
					door.position.set(actual.poste.position.x, actual.poste.position.y + this.DTHeightPerimeter, actual.poste.position.z);
					door.rotation.set(0, r, 0);
					this.DTRootPerimeter.add(door);
				}
			}
			//############################################################################
			// HAY MÁS DE UNA SECCIÓN, PUEDE HABER COMBINACIÓN DE PUERTAS Y MALLAS.
			else {
				let auxActual = actual.poste.position.clone();
				let auxNext: THREE.Vector3;
				let magnitud = actual.poste.position.distanceTo(next.poste.position);

				const _lastSection = tramo.sections.length - 1;
				for (let iSection = 0; iSection < tramo.sections.length; iSection++) {
					// Obtener la section.
					let section = tramo.sections[iSection];

					// Si no es la primera sección, se debe crear el poste base.
					if (iSection > 0) {
						let objs = this.rayMaps(auxNext);
						if (objs.length > 0) {
							let o = objs[0];
							let _angle = this.angleAtoB(auxActual, auxNext);
							// Coloca el poste base.
							let poste = this.datasSatelite.postes.clonePost(this.DTPerimeterActual.typePost,
								'poste_' + this.DTIndexPerimeter + '_' + this.DTCountPost++, 0, 0, -this.DTPerimeterActual.direction);
							poste.rotation.set(0, _angle, 0);

							// Pintar el poste.
							if (this.DTHasColor) this.paintPost(poste);

							poste.position.set(o.point.x, o.point.y - this.DTHeightPerimeter, o.point.z);

							this.DTRootPerimeter.add(poste);
							auxActual = poste.position; // Toma el relevo como poste base principal.
						}
					}

					// No es una puerta, poner solo mallas.
					if (section.door === '') {
						// Tener en cuenta que es la última sección.
						let magnitudAux = (iSection == (tramo.sections.length - 1)) ? magnitud : section.magnitud;

						// Crear un poste ficticio.
						auxNext = this.tramoAtoB(auxActual, next.poste.position, magnitudAux);
						this.drawPostesSectionCercado(auxActual, auxNext);
						magnitud -= magnitudAux;
						if (iTramo > 0 && tramo.grados >= 40 && tramo.grados <= 140) {
							if (iSection === 0) {
								this.setTornapuntas2(Varios3d.TornaPuntasDerecho, actual.poste.position, previousAngle);
								this.setTornapuntas2(Varios3d.TornaPuntasIzquierdo, actual.poste.position, actualAngle);
							}
						}

						// Colocar uno de los tornapuntas que encierra la puerta.
						if (iSection > 0 && tramo.sections[iSection - 1].door !== '') {
							this.setTornapuntas2(Varios3d.TornaPuntasIzquierdo, auxActual, actualAngle);
						}
					}
					else { // Es una puerta, solo poner la puerta, sus postes pertenecen a los postes base.
						// Mover auxActual para que no se meta en el poste.
						let diametroPoste = this.datasSatelite.postes.length(this.DTPerimeterActual.typePost);
						auxActual = this.tramoAtoB(auxActual, next.poste.position, diametroPoste / 2);

						// Sacar el poste ficticio que en marca la puerta.
						let lengthDoor = this.datasSatelite.puertas.length(section.door);
						if (lengthDoor === 0) lengthDoor = section.magnitud;
						auxNext = this.tramoAtoB(auxActual, next.poste.position, lengthDoor + diametroPoste / 2);

						magnitud -= (lengthDoor + diametroPoste);

						// Pone un poste y después la puerta, tener en cuenta la orientación y rotación.
						let door = this.datasSatelite.puertas.cloneDoorSateliteData(section.door, this);
						if (door) {
							let r = this.angleAtoB(auxActual, auxNext);
							door.position.set(auxActual.x, auxActual.y + this.DTHeightPerimeter, auxActual.z);
							door.rotation.set(0, r, 0);
						}
						else {
							console.error('this.subPostesCercados, no encuentra la puerta ' + section.door);
						}
						// Colocar el otro tornapuntas que encierra la puerta.
						if (iSection > 0) {
							this.setTornapuntas2(Varios3d.TornaPuntasDerecho, auxActual, actualAngle);
						}

						if (iTramo > 0 && tramo.grados >= 40 && tramo.grados <= 140) {
							if (iSection === 0) {
								// Inicio de los tramos sin ser el primero.
								// Si la última sección del anterior tramo es una puerta no poner el tornapuntas.
								const _lastT = this.DTPerimeterActual.coors[iTramo - 1];
								const _lastS = _lastT.sections[_lastT.sections.length - 1];
								if (_lastS.door === '') {
									this.setTornapuntas2(Varios3d.TornaPuntasDerecho, actual.poste.position, previousAngle);
								}
								//this.setTornapuntas2(Varios3d.TornaPuntasIzquierdo, actual.poste.position, actualAngle);
							}
						}

						this.DTRootPerimeter.add(door);
					}
				}
			}
		}
	}

	// ##### Dibuja una parte o todo un tramo con el cercado indicado.
	private drawPostesSectionCercado(posteA: THREE.Vector3, posteB: THREE.Vector3) {
		let length = posteA.distanceTo(posteB);
		let angle = this.angleAtoB(posteA, posteB);

		if (length > this.DTPerimeterActual.separation) {
			// Unidad divisoría de la malla.
			let unidad = this.DTPerimeterActual.separation / 100;

			let div = Math.floor(length / this.DTPerimeterActual.separation);
			let margenEnd = length % this.DTPerimeterActual.separation;
			let margenStart = this.DTPerimeterActual.separation;

			// En caso de que el resto sea un 30% más pequeño que la medida del malla => distribuir.
			if ((margenEnd / unidad) < 30) {
				margenStart = (margenStart + margenEnd) / 2;
				margenEnd = margenStart;
			}
			// Poner postes.
			let postes = [posteA]; // Colocar el poste base 'posteA' en primer puesto.
			let inicioDraw = margenStart;
			let inicioRect = 0; // Contador de postes hasta colocar el poste con tornapuntas (10).
			if (div > 9) {
				let rx = ((div - 1) - ((Math.floor(div / 10) - 1) * 10));
				inicioRect = Math.floor(rx / 2);
				if ((rx % 2) !== 0) inicioRect++;
				inicioRect = 10 - (inicioRect + 1);
			}
			for (let i = 0; i < div; i++) {
				let objs = this.rayMapsAtoB(posteA, posteB, inicioDraw);
				let poste;
				if (objs.length > 0) {
					let o = objs[0];
					poste = this.datasSatelite.postes.clonePost(this.DTPerimeterActual.typePost,
						'poste_' + this.DTCountPost++, 0, 0, -this.DTPerimeterActual.direction);
					poste.position.set(o.point.x, o.point.y - this.DTHeightPerimeter, o.point.z);
					poste.rotation.set(0, angle, 0);
					// Pintar el poste.
					if (this.DTHasColor) this.paintPost(poste);

					// Almacenar los postes para la segunda vuelta, colocar las mallas.
					postes.push(poste.position);

					this.DTRootPerimeter.add(poste);
				}
				// Postes intermedios con tornapuntas.
				inicioRect++;
				if (inicioRect === 10) {
					if (poste) {
						this.setTornapuntas2(Varios3d.TornaPuntasRecto, poste.position, angle);
					}
					inicioRect = 0;
				}

				inicioDraw += this.DTPerimeterActual.separation;
			}
			postes.push(posteB); // La lista debe finalizar con el poste base 'posteB'.

			// Colocar las mallas. Puntero a los datos del bastidor.
			for (let iPoste = 0; iPoste < postes.length - 1; iPoste++) {
				let vA = postes[iPoste].clone();
				let vB = postes[iPoste + 1].clone();
				let r = this.angleAtoB(vA, vB);

				let lengthMalla = 0;
				if (iPoste === postes.length - 2 && margenEnd !== this.DTPerimeterActual.separation) {
					lengthMalla = this.DTPerimeterActual.separation - margenEnd;
				}
				// _____ ANUDADA
				if (this.DTPerimeterActual.mesh.startsWith('LUX_ANUDADA')) {
					this.drawCercadoAnudada(vA, vB, r);
				}
				else {
					let bas = this.datasSatelite.bastidores.cloneEspecialLUX(this.DTPerimeterActual.mesh, vA, vB,
						-this.DTPerimeterActual.direction, this.datasSatelite.ColorNeutro, this.DTHasColor,
						this.datasSatelite.ColorNeutro, this.DTCacheMaterials.COL_Abrazadera);

					bas.position.set(vA.x, vA.y + this.DTHeightPerimeter + this.DTPerimeterActual.heigthWall, vA.z);

					// Rotar la malla.
					bas.rotation.set(0, angle, 0);
					this.DTRootPerimeter.add(bas);

					// ######### MARCADOR
					this.setMarcador(bas.position, angle);
				}

				// Placa base, bayoneta y muro.
				this.extrasCercados(vA, vB, r, (iPoste === 0), (iPoste === (postes.length - 2)), lengthMalla);
			}
		}
		else {
			// _____ ANUDADA
			if (this.DTPerimeterActual.mesh.startsWith('LUX_ANUDADA')) {
				this.drawCercadoAnudada(posteA, posteB, angle);
			}
			else {
				let bas = this.datasSatelite.bastidores.cloneEspecialLUX(this.DTPerimeterActual.mesh, posteA, posteB,
					-this.DTPerimeterActual.direction, this.datasSatelite.ColorNeutro, this.DTHasColor,
					this.datasSatelite.ColorNeutro, this.DTCacheMaterials.COL_Abrazadera);

				bas.position.set(posteA.x, posteA.y + this.DTHeightPerimeter + this.DTPerimeterActual.heigthWall, posteA.z);

				//let r = this.angleAtoB(posteA, posteB);
				bas.rotation.set(0, angle, 0);
				this.DTRootPerimeter.add(bas);

				// ######### MARCADOR
				this.setMarcador(bas.position, angle);
			}
			// Placa base, bayoneta y muro.
			this.extrasCercados(posteA, posteB, angle, true, true, this.DTPerimeterActual.separation - length);
		}
	}

	// Dibuja malla anudada desde el pointA al pointB.
	// Se inicia con malla (Inicial, tiene las carracas al inicio y solo se puede colocar al inicia un tramo nuevo 'al principio, después de una puerta').
	// Si ya está iniciada dibuja malla de relleno hasta que llega a 59.9 metros donde debe dibujar malla con carracas e iniciar con 0.8 metros.
	private drawCercadoAnudada(pointA: THREE.Vector3, pointB: THREE.Vector3, angle: number) {
		if (!pointA || !pointB) return;

		// Longitud a cubrir.
		let length = pointA.distanceTo(pointB);

		let vA = pointA.clone();

		// ##### SE INICIA TRAMO DE 60 METROS.
		// Se tiene que consumir la langitud.
		while (length > 0) {
			// ##### ANUDADA CENTRAL
			if (this.DTMetersLUXAnudada > 0 && this.DTMetersLUXAnudada < 59.9) {
				// Dibuja relleno.
				if ((this.DTMetersLUXAnudada + length) < 59.9) { // Colocar entero, gasta toda la longitud.
					this.__setAnudada(this.DTAnudadas.centro, vA, pointB, length, angle);
					return; // No queda mas longitud a gastar length = 0.
				}
				else {
					let consume = 59.9 - this.DTMetersLUXAnudada;
					// Obtener la posición vB.
					let v3 = this.tramoAtoB(vA, pointB, consume);
					let obj = this.rayMaps(v3); // Obetener la colisión para saber la altura.
					if (obj.length > 0) {
						let o = obj[0];
						o.point.y -= this.DTHeightPerimeter;
						this.__setAnudada(this.DTAnudadas.centro, vA, o.point, consume, angle);
						vA.set(o.point.x, o.point.y, o.point.z);
					}
					// Se ha llegado al final, poner parcial y dejar para carracas.
					this.DTMetersLUXAnudada = 59.9; // Siguiente ronda dibuja carracas.
					length -= consume;
				}
			}
			// ##### ANUDADA CARRACAS
			if (this.DTMetersLUXAnudada === 59.9) {
				if ((this.DTMetersLUXAnudada + length) <= 60) {
					this.__setAnudada(this.DTAnudadas.carracas, vA, pointB, length, angle);
					this.DTMetersLUXAnudada = 0.9;
					return; // No queda mas longitud a gastar length = 0.
				}
				else {
					// Obtener la posición vB.
					let v3 = this.tramoAtoB(vA, pointB, 0.9);
					let obj = this.rayMaps(v3); // Obetener la colisión para saber la altura.
					if (obj.length > 0) {
						let o = obj[0];
						o.point.y -= this.DTHeightPerimeter;
						this.__setAnudada(this.DTAnudadas.carracas, vA, o.point, 0.9, angle);
						vA.set(o.point.x, o.point.y, o.point.z);
					}
					this.DTMetersLUXAnudada = 0.9;
					length -= 0.9;
				}
			}
			// ##### ANUDADA INICIAL
			if (this.DTMetersLUXAnudada === 0) {
				// Si la longitud es menor de (0.9 metros) que es lo que mide la malla inicial, se trata aparte.
				if (length < 0.9) {
					this.__setAnudada(this.DTAnudadas.inicial, pointA, pointB, length, angle);
					return; // No queda mas longitud a gastar length = 0.
				}
				else {
					// Obtener la posición vB.
					let v3 = this.tramoAtoB(vA, pointB, 0.9);
					let obj = this.rayMaps(v3); // Obetener la colisión para saber la altura.
					if (obj.length > 0) {
						let o = obj[0];
						o.point.y -= this.DTHeightPerimeter;
						this.__setAnudada(this.DTAnudadas.inicial, vA, o.point, 0.9, angle);
						vA.set(o.point.x, o.point.y, o.point.z);
					}
					length -= 0.9;
				}
			}
		}
	}
	private __setAnudada(type: string, vA: THREE.Vector3, vB: THREE.Vector3, length: number, angle: number) {
		this.DTMetersLUXAnudada += length;
		let bas = this.datasSatelite.bastidores.cloneEspecialAnudadaXYZ(type, vA, vB, length,
			this.DTHeightPerimeter + this.DTPerimeterActual.heigthWall, this.DTPerimeterActual.direction);
		bas.rotation.set(0, angle, 0);
		this.DTRootPerimeter.add(bas);

		// ######### MARCADOR
		this.setMarcador(bas.position, angle);
	}

	// ##### Cambia el color de un poste y su bayoneta si la tiene.
	public paintPost(post: any) {
		if (!post) return;

		for (let obj = 0; obj < post.children.length; obj++) {
			let element = post.children[obj];
			if (element.name.startsWith('Poste')) {
				element.material = this.DTCacheMaterials.COL_Poste;
			}
			else if (element.name.startsWith('BAYONETA')) {
				element.material = this.DTCacheMaterials.COL_Bayoneta;
			}
		}
	}

	// ##### Añade un tornapuntas.
	private setTornapuntas2(obj: string, point: THREE.Vector3, angle: number) {
		// ESPRRIVISA-132
		const tor = this.DTPerimeterActual.typePost === "LUX50G" ? this.datasSatelite.varios.clone(obj + this.DTColorTornapuntas) : this.datasSatelite.varios.clone(obj);
		tor.name = obj + this.DTNamePerTramo + this.DTCountTornaPuntas++;
		tor.position.set(point.x, point.y + this.DTHeightTornapuntas, point.z);
		tor.scale.z = this.DTPerimeterActual.direction;
		tor.rotation.y = angle;

		// Color.
		if (this.DTHasColor) {
			for (let obj of tor.children) obj.material = this.datasSatelite.ColorNeutro;
		}
		this.DTRootPerimeter.add(tor);
	}

	// ##### Colocar placa base.
	public setPlacaBase2(post: THREE.Vector3, angle: number, height: number) {
		let pla = this.datasSatelite.varios.clone(Varios3d.PlacaBase);
		if (pla) {
			pla.position.set(post.x, height + this.DTPerimeterActual.heigthWall, post.z);
			pla.rotation.y = angle;
			pla.name = 'PlaqueBase' + this.DTNamePerTramo + this.DTCountPlaqueBase++;

			// Color.
			if (this.DTHasColor) {
				pla.children[0].material = this.DTCacheMaterials.COL_PlacaBase;
			}

			this.DTRootPerimeter.add(pla);
		}
	}

	// ##### 'point' punto donde se lanza el rayo vertical contra el mapa.
	private rayMaps(point: THREE.Vector3) {
		point = point.clone();
		point.setY(point.y + 1000);
		let pointUp = new Vector3(0, -10000, 0);
		pointUp.addVectors(point, this.__direction.multiplyScalar(this.__distance));

		this.__ray.set(point, this.__direction.subVectors(pointUp, point).normalize());

		return this.__ray.intersectObjects(this.gestorSatelite3d.meshesMap);
	}

	private rayMapsFromPoint(point: THREE.Vector3, aListOfMeshes) {
		//point = point.clone();
		//point.setY(point.y);

		//pointUp.addVectors(point, this.__direction.multiplyScalar(this.__distance));

		this.__ray.set(point, this.__direction.normalize());

		return this.__ray.intersectObjects(aListOfMeshes);
	}

	// ##### Retorna el Vector3 entre 'pointA' y 'pointB' partiendo de 'pointA' con el marge 'tramo'.
	private tramoAtoB(pointA: THREE.Vector3, pointB: THREE.Vector3, tramo: number): THREE.Vector3 {
		let v = pointB.clone().sub(pointA).normalize().multiplyScalar(tramo);
		return pointA.clone().add(v);
	}

	// ##### La colisión con el mapa, si la hay, en el punto relativo 'tramo' entre los puntos 'pointA' y 'pointB'.
	private rayMapsAtoB(pointA: THREE.Vector3, pointB: THREE.Vector3, tramo: number) {
		const p1:THREE.Vector3 = pointA.clone();
		const p2:THREE.Vector3 = pointB.clone();

		p1.y=0;
		p2.y=0;

		let v =  p2.sub(p1).normalize().multiplyScalar(tramo);
		let point = p1.add(v);
		point.setY(point.y + 1000);

		let pointUp = new Vector3(0, 0, 0);
		pointUp.addVectors(point, this.__direction.multiplyScalar(this.__distance));
		this.__ray.set(point, this.__direction.subVectors(pointUp, point).normalize());


		return this.__ray.intersectObjects(this.gestorSatelite3d.meshesMap);
	}

	private angleAtoB(va: THREE.Vector3, vb: THREE.Vector3) {
		let negativo = false;
		if (va.x > vb.x) negativo = (va.z < vb.z); else negativo = (va.z < vb.z);

		let v = new THREE.Vector3(vb.x - va.x, 0, vb.z - va.z);
		let v0 = new THREE.Vector3(0, 0, 0);
		let hipo = v0.distanceTo(v);
		let coX = v.x;
		let coY = v.y;
		let acos = Math.acos(coX / hipo);
		if (negativo) return -acos;
		return acos;
	}

	private initWorld3D() {
		// Crear root del proyeto (debería ser el centro).
		this.root = new THREE.Object3D();
		this.root.name = 'ROOT';
		this.scene.add(this.root);

		// if (this.__debug) {
		// 	let axisHelper = new THREE.AxesHelper(5);
		// 	this.root.add(axisHelper);
		// }

		// Grupo de trabajo, contiene puntos base para debug.
		this.work = new THREE.Group();
		this.work.name = 'WORK'
		this.root.add(this.work);

		// Grupo de marcadores, cuando la cámara esté una distancia determinada se hace visible.
		this.marcador = new THREE.Group();
		this.marcador.name = 'MARCADORES';
		this.marcador.visible = false;
		this.root.add(this.marcador);

		//axisHelper = new THREE.AxesHelper(10); this.work.add(axisHelper);
	}

	// Creamos BoundMap (google.maps.LatLngBounds), al que se añade todos los puntos base de todos los perímetros, obteniendo así el rectangulo
	// total. De esta forma se obtiene el centro y se puede decidir cuantas tildes hay que crear.
	private async calcularBoundMap() {
		this.gestorSatelite3d = new GestorSatelite3d(this.projectData.perimetro, this.root, undefined, false);
		await this.gestorSatelite3d.createMosaicAsync();

		this.SVectorAdjust = UtilsBuilder.latLngToVector3d(this.gestorSatelite3d.lat, this.gestorSatelite3d.lng);
		// VERSIÓN ANTIGUA: CORRECCIÓN DE PERÍMETROS QUE SE ALEJAN DE BARCELONA. LatLngToXYZ
			// TODO Rectificar para dejar como antes: Descomentar.
		// const SGradosLAT = 90 - this.gestorSatelite3d.lat;
		// const SRadianesLAT = UtilsBuilder.AngleToRadian(SGradosLAT);
		// const SGradosLNG = 180 - this.gestorSatelite3d.lng;
		// const SRadianesLNG = UtilsBuilder.AngleToRadian(SGradosLNG);
	}

	private drawBasePerimeters() {
		// VERSIÓN ANTIGUA: CORRECCIÓN DE PERÍMETROS QUE SE ALEJAN DE BARCELONA. LatLngToXYZ
		// TODO Rectificar para dejar como antes: Comentar.
		let SGradosLAT = 90 - this.gestorSatelite3d.lat;
		let SRadianesLAT = UtilsBuilder.AngleToRadian(SGradosLAT);
		let SGradosLNG = this.gestorSatelite3d.lng;
		let SRadianesLNG = UtilsBuilder.AngleToRadian(SGradosLNG);

		// Conos rojos.
		let cone = new THREE.ConeGeometry(0.01, 0.01);
		const matYellow = new THREE.MeshBasicMaterial({ color: 0xffff00 });
		for (let [ip, p] of this.projectData.perimetro.entries()) {

			// DEBUG
			// this.__debugPerimeter(ip, p);
			// DEBUG

			let subBase = [];
			let g = new THREE.Group();
			g.name = "BASE_" + ip;
			this.work.add(g);
			for (let [id, c] of p.coordenadas.entries()) {
				let v = UtilsBuilder.latLngToVector3d(
					c.dots[0].lat,
					c.dots[0].lng);
				let dot = new THREE.Mesh(cone, matYellow);
				dot.name = 'Tope_' + ip + '_' + id;
				dot.visible = false;
				dot.position.set(v.x - this.SVectorAdjust.x, v.y - this.SVectorAdjust.y, v.z - this.SVectorAdjust.z);
				//dot.rotation.x = this.SRadianesLAT;
				//dot.rotation.z = this.SRadianesLNG;
				g.add(dot);
				subBase.push(dot);
			}
			this.bases.push(subBase);
		}

		this.work.rotation.x = -SRadianesLAT;
		this.work.rotation.y = -SRadianesLNG;
	}

	public calculatePoleSizes()
	{
		let oPoleTops = {};
		const oSatMeshes  = this.gestorSatelite3d.meshesMap;
		const oWallMeshes = [];

		let oPerimeterList = this.root.children.filter( pole  => pole.name.startsWith("Perimeter_") );
		let iNumOfPerimeters = oPerimeterList.length;
		let iPerimeterCount = 0;
		for( iPerimeterCount = 0; iPerimeterCount < iNumOfPerimeters ; iPerimeterCount++ ) {
			let currPerim = oPerimeterList[iPerimeterCount];
			let oPolesList = currPerim.children.filter( pole  => pole.name.startsWith("poste_") === true );


			let iNumOfPoles = oPolesList.length;
			let iPoleCount = 0;
			for( iPoleCount = 0; iPoleCount < iNumOfPoles ; iPoleCount++ ) {
				let currPole = oPolesList[iPoleCount];

				let box = new THREE.Box3();
				let  boxGroup = new THREE.Group();
				boxGroup.name = "Top_" + iPoleCount

				box.setFromObject(currPole);

				let aMax = box.max;
				let aCenter = new THREE.Vector3(0.0, 0.0, 0.0);
				box.getCenter ( aCenter );

				let aTop = new THREE.Vector3( aCenter.x, aMax.y, aCenter.z );

				oPoleTops[currPole.name] = aTop;
			}

			let oWallGroupList = currPerim.children.filter( pole  => pole.name.startsWith("wall") === true );
			let oWallList = [];
			let iNumOfWalls = oWallGroupList.length;
			let iWallCount = 0;
			for( iWallCount = 0; iWallCount < iNumOfWalls ; iWallCount++ ) {
				console.log("wall" + iWallCount);
				let currWallGroup = oWallGroupList[iWallCount];
				let currWallGroupPos = currWallGroup.position;
				let currWallGroupRot = currWallGroup.rotation;
				let currWallGroupSca = currWallGroup.scale;

				let currWallGroupMW = currWallGroup.matrixWorld;
				let aCurrWallMeshes = currWallGroup.children;

				let iNumOfMeshes = aCurrWallMeshes.length;
				let iMeshCount = 0;
				for(iMeshCount = 0; iMeshCount < iNumOfMeshes; iMeshCount++) {
					let oMeshWithPosition = aCurrWallMeshes[iMeshCount].clone();
					oMeshWithPosition.position.set(currWallGroupPos.x, currWallGroupPos.y, currWallGroupPos.z);
					oMeshWithPosition.scale.set(currWallGroupSca.x, currWallGroupSca.y, currWallGroupSca.z);
					oMeshWithPosition.setRotationFromEuler(currWallGroupRot);

					oMeshWithPosition.updateMatrixWorld(true);

					oWallMeshes.push(oMeshWithPosition);
				}

			}


		}


		const allMeshes = [...oSatMeshes, ...oWallMeshes];
		let iNumOfTops =  Object.keys(oPoleTops).length;
		let iTopCount = 0;
		let lengthsPosts = [];
		for( iTopCount = 0; iTopCount < iNumOfTops; iTopCount++ ) {
			let currTopPoint = oPoleTops[Object.keys(oPoleTops)[iTopCount]];

			let oIntersections = this.rayMapsFromPoint(currTopPoint, allMeshes);
			if( oIntersections.length > 0 ) {
				let y = 0;
				let iNumOfInt = oIntersections.length;
				// console.log( iNumOfInt + " intersections. First is:" + oIntersections[0].object.name + " (distance: " + oIntersections[0].distance +  ")");
				lengthsPosts.push(oIntersections[0]);
			}
		}

		return lengthsPosts;
	}

	// ESPRRIVISA-128
	// Return the number of double poles: this.DTPerimeterActual.coors.0.posteAdicional contains coordinates of the additional pole if exists and "undefine" if not.
	public countDoublePost() {
		let tramos = this.DTPerimeterActual.coors;
		let quantityDoublePosts = 0;

		for (let index = 0; index < tramos.length - 1; index++) {
			if(tramos[index].posteAdicional.x){
				quantityDoublePosts++;
			}
		}

		return quantityDoublePosts;
	}
}
